/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedPersonalizedFilterToast_shippingFilters = ReadonlyArray<{
    readonly totalCount: number | null;
    readonly " $refType": "SbSharedPersonalizedFilterToast_shippingFilters";
}>;
export type SbSharedPersonalizedFilterToast_shippingFilters$data = SbSharedPersonalizedFilterToast_shippingFilters;
export type SbSharedPersonalizedFilterToast_shippingFilters$key = ReadonlyArray<{
    readonly " $data"?: SbSharedPersonalizedFilterToast_shippingFilters$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedPersonalizedFilterToast_shippingFilters">;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedPersonalizedFilterToast_shippingFilters",
  "type": "ShippingFilterType",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalCount",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '62ccccb1a602b84a1bef0784594396d5';
export default node;
